import { useEffect, useRef } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Subscribe to a server-sent events channel.
 * path examples: `/stream/event/<id>` (public) or `/stream/org/<id>?token=<jwt>`.
 * onMessage receives the parsed payload (e.g. { type: "questions" }).
 */
export function useSSE(path, onMessage, enabled = true) {
  const cbRef = useRef(onMessage);
  cbRef.current = onMessage;

  useEffect(() => {
    if (!enabled || !path) return;
    const url = `${BACKEND_URL}/api${path}`;
    let es;
    try {
      es = new EventSource(url);
      es.onmessage = (e) => {
        try { cbRef.current?.(JSON.parse(e.data)); } catch { /* ignore heartbeats */ }
      };
      es.onerror = () => { /* EventSource auto-reconnects */ };
    } catch { /* ignore */ }
    return () => { es && es.close(); };
  }, [path, enabled]);
}
